export function areTextInputsEmpty(formValues) {
  // true if every input is empty string or not a text input
  return Object.values(formValues).every((inputValue) => (
    (
      // skip non-text inputs (value isn't a string)
      // https://stackoverflow.com/a/9436948
      !(typeof inputValue === 'string' || inputValue instanceof String)
      // if it is a string, is it empty?
      || inputValue === ''
    )
  ));
}

export default areTextInputsEmpty;
